import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  RESET_FILTERS_SUCCESS,
  SEARCH_CLIENTS_SUCCESS,
  SET_DATES,
  SET_LOADING,
  TABLE_LOADING,
  UPDATE_FILTERS
} from "./clientProfileSearchSagas";

export const initialState = {
  currentUser: {},
  searchResults: {
    tableInfo: {}
  },
  isLoading: true,
  showTable: false,
  tableLoading: false,
  filters: {},
  selectedFilters: {
    profileCreatedDate: { startDate: "", endDate: "" },
    firstVisitDate: { startDate: "", endDate: "" },
    membership_types: [],
    lead_types: [],
    profile_statuses: []
  }
};

export default handleActions(
  {
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),

    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),

    [TABLE_LOADING]: (state) => ({
      ...state,
      tableLoading: true
    }),
    [SEARCH_CLIENTS_SUCCESS]: (state, action) => ({
      ...state,
      searchResults: action.payload.data || state.searchResults,
      tableLoading: false,
      filtersDirty: false
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      filters: { profileCreatedDate: action.payload, firstVisitDate: action.payload },
      selectedFilters: {
        ...state.selectedFilters,
        profileCreatedDate: action.payload,
        firstVisitDate: action.payload
      }
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => {
      let filters = {};

      for (let key in action.payload) {
        filters = {
          ...filters,
          [key]: action.payload[key].map((filter, id) => ({ ...filter, id }))
        };
      }

      return {
        ...state,
        filters: { ...state.filters, ...filters },
        selectedFilters: { ...state.selectedFilters, ...filters }
      };
    },
    [UPDATE_FILTERS]: (state, { payload: { data, key } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, [key]: data }
    }),
    [RESET_FILTERS_SUCCESS]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: state.filters
    })
  },
  initialState
);
